<template>
  <div id="app">
    <v-app id="inspire">
      <template v-if="loading">
        <v-container align-center justify-center fill-height fluid wrap>
          <breeding-rhombus-spinner :animation-duration="2000" :size="65" color="blue"/>
        </v-container>
      </template>
      <template v-else>
        <v-container
          style="background: #005cb9"
          align-center
          justify-center
          fill-height
          grid-list-xl
        >
          <v-layout wrap justify-center align-center fill-height>
            <v-flex xs12>
              <v-card :color="colorCard" class="elevation-10">
                <v-card-title class="pt-4 font-title font-weight-black font-italic">Welcome ..</v-card-title>
                <v-card-text
                  class="font-instruction pt-1 font-weight-bold"
                >Instruksi : Setiap nomor dibawah ini memuat 4 (empat) kalimat. Tugas anda adalah :</v-card-text>
                <v-card-text class="font-instruction py-1">
                  1. Silahkan pilih salah satu pilihan
                  <kbd>P</kbd> di samping kalimat yang
                  <kbd>PALING menggambarkan</kbd> diri anda
                </v-card-text>
                <v-card-text class="font-instruction py-1">
                  2. Silahkan pilih salah satu pilihan
                  <kbd>K</kbd> di samping kalimat yang
                  <kbd>PALING tidak menggambarkan</kbd> diri anda
                </v-card-text>
                <v-card-text class="font-instruction py-1">
                  <code>PERHATIKAN : Setiap Soal hanya ada 2 jawaban, satu di P dan satu di K</code>
                </v-card-text>

                <!-- <v-container fluid grid-list-XS>
                  <v-layout row wrap>
                    <v-flex v-for="rule in rules" :key="rule" XS>
                      <v-img :src="rule"></v-img>
                    </v-flex>
                  </v-layout>
                </v-container> -->
              </v-card>
            </v-flex>

            <v-flex xs12 class="pt-0">
              <v-card :color="colorCard" class="elevation-10">
                <div class="text-xs-left white--text text--darken-2">
                  <v-progress-linear
                    :indeterminate="indeterminate"
                    :size="100"
                    :width="15"
                    height="5"
                    :value="value"
                    color="forty"
                  ></v-progress-linear>
                </div>
                <v-card-title class="font-title black--text font-weight-black">GAMBARAN DIRI</v-card-title>
                <v-card-text
                  v-for="(item, index) in chapters"
                  :key="index"
                  v-show="index+1 == questionIndex"
                >
                  <span class="font-title font-weight-regular mb-4">Soal {{item.chapter}}</span>
                  <br>
                  <v-spacer/>
                  <v-divider></v-divider>
                  <br>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-layout
                      class="font-question"
                      :style="{background : (key%2===0? '#fafafa' : '#eeeeee')}"
                      row
                      wrap
                      v-for="(topic, key) in item.topics"
                      :key="topic.id"
                    >
                      <v-spacer></v-spacer>
                      <v-flex xs8 class="text-xs-left py-2">
                        <span class="pt-1">{{topic.question}}</span>
                      </v-flex>
                      <v-flex xs2 class="text-xs-left pt-0 pl-2">
                        <v-radio-group class="radio-button" v-model="userResponsesP[index]" row>
                          <v-radio color="sixty" label="P" :value="topic.answer_p"></v-radio>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs2 class="text-xs-left pt-0 pl-1">
                        <v-radio-group class="radio-button" v-model="userResponsesK[index]" row>
                          <v-radio color="sixty" label="K" :value="topic.answer_k"></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>

                    <v-divider light class="mr-2"></v-divider>
                  </v-form>
                  <span
                    v-if="userResponsesK.length == 24 && userResponsesP.length == 24"
                    class="caption Product-Sans font-weight-medium sixty--text text-xs-center font-italic"
                  >
                    <v-icon light small class="sixty--text darken-3">done_all</v-icon>&nbsp;
                    periksa kembali jawaban anda, silahkan gunakan fitur dibawah untuk ke halaman tertentu
                  </span>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="sixty"
                    :disabled="questionIndex < 2 || 
                  userResponsesK[this.questionIndex-1] == userResponsesP[this.questionIndex-1]? true:false"
                    depressed
                    small
                    round
                    @click="prev"
                  >
                    <v-icon dark>keyboard_arrow_left</v-icon>prev
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="sixty"
                    v-show="questionIndex !== chapters.length"
                    depressed
                    small
                    round
                    :disabled="userResponsesK[this.questionIndex-1] == null? true:false || 
                  userResponsesP[this.questionIndex-1] == null? true:false || 
                  userResponsesK[this.questionIndex-1] == userResponsesP[this.questionIndex-1]? true:false"
                    @click="next"
                  >
                    next
                    <v-icon dark>keyboard_arrow_right</v-icon>
                  </v-btn>
                  <v-btn
                    color="sixty"
                    v-show="questionIndex === chapters.length"
                    depressed
                    small
                    round
                    @click="finish"
                    :disabled="userResponsesK.length != 24 || userResponsesP.length != 24 || 
                  loading || userResponsesP[this.questionIndex-1] == null? true:false || 
                  userResponsesK[this.questionIndex-1] == userResponsesP[this.questionIndex-1]? true:false"
                  >finish</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12>
              <v-card :color="colorCard" class="elevation-10">
                <div class="text-xs-center">
                  <v-container>
                    <v-layout justify-center>
                      <v-flex xs12 sm10 md8>
                        <v-card flat>
                          <v-card-text
                            v-if="userResponsesK.length < 24 || userResponsesP.length < 24"
                            class="caption forty--text text--lighten-2 text-xs-center pt-3"
                          >
                            <v-icon light small color="red lighten-2">error</v-icon>&nbsp;
                            Fitur ini hanya dapat digunakan saat semua jawaban terisi
                          </v-card-text>
                          <v-pagination
                            :disabled="userResponsesK.length != 24 || userResponsesP.length != 24 || 
                          userResponsesK[this.questionIndex-1] == userResponsesP[this.questionIndex-1]? true:false"
                            v-model="questionIndex"
                            :length="24"
                            prev-icon="mdi-menu-left"
                            next-icon="mdi-menu-right"
                            color="sixty"
                            circle
                          ></v-pagination>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </v-app>
  </div>
</template>

<style lang="stylus" scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>

<style scoped>
.font-title {
  letter-spacing: 0.1em;
  font-family: "Product Sans" !important;
  font-size: 24px !important;
  line-height: 5px;
  color: black;
}

.font-instruction {
  letter-spacing: 0.025em;
  font-family: "Product Sans" !important;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 500;
  color: black;
}

.font-question {
  letter-spacing: 0.05em;
  font-family: "Product Sans" !important;
  font-size: 14px;
  line-height: 1em !important;
  margin-top: -10px !important;
  margin-bottom: 10px !important;
  font-weight: 500;
  box-sizing: border-box !important;
  width: 100% !important;
  height: 40px !important;
  padding-top: 0px !important;
  color: black;
}

.radio-button {
  margin-top: 2px !important;
}
</style>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { BreedingRhombusSpinner } from "epic-spinners";

export default {
  name: "c-test",

  components: {
    BreedingRhombusSpinner
  },

  data() {
    return {
      topics: [],
      chapters: [],
      interval: {},
      value: 4,
      valid: true,
      indeterminate: true,
      questionIndex: 1,
      userResponsesP: [],
      userResponsesK: [],
      answer: "",

      pagination: {},
      loading: false,
      colorCard: "#fafafa",
      rules: [
        "https://lh3.googleusercontent.com/4Y5Xrh-J-GBfXHZ1RGBpo5Fo_ssBwVABx993N0XHnZAn3diCWSspSs_Hiq7Jz_U5v_uwu6W1xU0P5xVNYNCMdjGDg8ItKvbZUkvRlARM6abkOdTxnUXcbBWLcviHCY5_jJGjwUMH=w276-h162-no",
        "https://lh3.googleusercontent.com/fuQxtCAPavayCQDpHver8HPRBRpvP3GvtZ3bTwq54MSBphmJhITgM-JSu3WmZLOuidVdt3pyargQWNmVse7aZX9C1NTQthOitw6hrXYTfniNnuLpIhI4K-Tgqx2-dGEqofYumGEzGK7IxxPOqqKw3-OL5Wnc1wENu3T9fIzQXQRMwVXEr0jI6Z4KgL7IrY62HaRMbiIDAlIG8CNZdFz5Uazq3Q5dbG-ft3IuUh0KlR5B3xyT0xEtFLd8HnECaRMJUd7R2CQeW5esawetx-V6zN4Y555thX5thGNh83OSm1U5eRjIV8N53IFZiEtoea-6BIafO-ZsnTsTbW3G4PQEqiwhzGNm5VgmZiYyJU4Q1HEgFnsT2TW5GvG4UVGVm0BGvlse80XN9hAFqi5qrhYkOh5lU69wmloRwcOjsvnV07jWCMlmeeRl6JvJe9X8li8SSd-aK9X-Hx-SuOMengECUsn8NH7p0AArPI-jd_E8luzbpMGNkWmLZcPeBqDGAoOoqXkpDRJ7oSUrqMlFH8_edzf3XP0NpZr4qo2jKLdFuDpiAwFJi7TXlouZfBVaxXIvdl298RC1QtKhsZW7ODD3s3whbrWDj57j2AwNACi07QsApMpvmbH-xglJbvs7TEskbAS81_wGN1bNPmcOeSKmqWlt10UW1A=w343-h200-no"
      ]
    };
  },

  computed: {
    ...mapGetters({
      applicant: "applicant",
      access: "access"
    })
  },

  created() {
    let urlTopics = "/chapters";

    this.axios
      .get(urlTopics)
      .then(response => {
        let data = response.data.data;
        this.chapters = data;
        this.indeterminate = false;
      })
      .catch(error => {
        let errors = error.response;

        console.log(errors);
      });
  },

  methods: {
    ...mapMutations("app", ["setAlert"]),
    ...mapActions({
      setApplicant: "setApplicant"
    }),

    next() {
      this.questionIndex++;
      this.value += 4;
    },

    prev() {
      this.questionIndex--;
      this.value -= 4;
    },

    finish() {
      this.loading = true;

      this.value += 8;

      let promise = Promise.resolve();
      let formData1 = new FormData();

      if (Object.keys(this.applicant).length !== 0) {
        for (let i = 0; i < 24; i++) {
          let formData = new FormData();

          formData.set("answer_p", this.userResponsesP[i]);
          formData.set("answer_k", this.userResponsesK[i]);
          formData.set("id_number", this.applicant.id_number);
          formData.set("chapter_id", i + 1);

          promise = promise.then(() => this.axios.post("/answers", formData));
        }

        promise
          .then(response => {
            formData1.set("id_number", this.applicant.id_number);
            formData1.set("token_test", this.access);

            Bus.$emit("setFinish");
            this.$store
              .dispatch("setFinish", formData1)
              .then(res => {
                this.$toast.success({
                  title: "Success",
                  message: "Terima kasih telah melakukan Disc Test"
                });

                this.loading = false;
                this.$router.push("/home");
              })
              .catch(err => {
                this.loading = false;
                this.$toast.error({
                  title: "Error",
                  message: "Gagal mengirim data"
                });
                console.log(err.response);
              });
          })
          .catch(error => {
            this.loading = false;
            this.$toast.error({
              title: "Error",
              message: "Gagal mengirim data"
            });
            console.log(error.response);
          });
      } else {
        this.$router.push("/home");
        this.$toast.error({
          title: "Error",
          message: "Maaf data gagal terkirim, ulangi lagi :("
        });
      }
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>